module.exports = __webpack_public_path__ + "img/defaultImageForSharing.5927d561.jpg";